import {httpService} from "@/modules/common/services"
import {getQuery} from "@/modules/common/utils"
import { httpGatewayService } from "@/modules/common/services";

const getMessages = (uid, params) => getQuery(`conversations/${uid}/messages`, params)

const sendMessage = async (uid, data) => {
    const res = await httpService.post(`conversations/${uid}/messages`, data);
    if (res.status === "Error") {
		return {error: res.message};
	} else {
		return {message: res}
  }
}
const sendMultipleMessages = async (data) => {
  try {
    const res = await httpService.post(`messages`, data);

    if (res.status === "Error") {
      return {error: res.message};
    } else {
      return {message: res}
    }
  } catch (error) {
    return {error};
  }
}

const update = async (uid, data) => {
	try {
		const res = await httpService.put(`conversations/${uid}`, data);
		return {conversation: res}
	} catch(e) {
		throw {error: e.message}
	}
}

const deleteRecording = async (recordingUid) =>
  httpGatewayService
    .remove(`v3/communication/voice_call_recordings/${recordingUid}`)
    .then((res) => res.data);

const markCallAsDone = async (callUid, staffUid) =>
  httpGatewayService
    .put(`v3/communication/voice_calls/${callUid}`, { handled_by_staff_uid: staffUid } )
    .then((res) => res.data);
const markRecordingAsListened = async (callUid) =>
  httpGatewayService
    .put(`v3/communication/voice_calls/${callUid}`, { recording: { recording_played: true } } )
    .then((res) => res.data);

const fetchCallTranscript = async (callUid) =>
  httpGatewayService
    .get(`v3/communication/voice_calls/${callUid}/transcript`)
    .then((res) => res.data);

export default {
	getMessages,
	sendMessage,
	sendMultipleMessages,
	update,
	deleteRecording,
	markCallAsDone,
  markRecordingAsListened,
  fetchCallTranscript,
}
